export const CARD_DATA = [
    {
        card: "A",
        no: "1",
        para: ` Build on your A1 knowledge and improve sentence formation, grammar accuracy, and conversation skills.`,
        duration: "3 Months",
        language: "English",
        linkTo: "a1"
    },
    {
        card: "A",
        no: "2",
        para: `Learn the basics of German language including grammar, vocabulary, and everyday expressions.`,
        duration: "3 Months",
        language: "English",
        linkTo: "a2"
    },
    {
        card: "B",
        no: "1",
        para: ` Strengthen your grammar, vocabulary, and communication skills for everyday German usage.`,
        duration: "3 Months",
        language: "English",
        linkTo: "b1"
    },
    {
        card: "B",
        no: "2",
        para: ` Move from B1 to C2 with a structured path to fluency and certification.`,
        duration: "3 Months",
        language: "English",
        linkTo: "b2"
    },
    {
        card: "C",
        no: "1",
        para: ` Advance from B1 to c2 with a clear, structured path to fluency and certification.`,
        duration: "3 Months",
        language: "English",
        linkTo: "c1"
    },
    {
        card: "C",
        no: "2",
        para: `Progress from B1 to C2 with a structured path to fluency and certification.`,
        duration: "3 Months",
        language: "English",
        linkTo: "c2"
    }
]